var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"点击扫码使用","placement":"right-start"}},[_c('div',{staticClass:"wechat-app",on:{"click":_vm.wechatCode}},[_c('div',[_c('img',{attrs:{"src":_vm.url,"alt":""}})]),_c('span',[_vm._v("小程序")])])]),_c('whole-confirm',{ref:"wholeConfirmRef"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }